import { render, staticRenderFns } from "./KioskConfiguration.vue?vue&type=template&id=8b2c3380"
import script from "./KioskConfiguration.vue?vue&type=script&lang=js"
export * from "./KioskConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports